import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { type Observable, Subject } from 'rxjs';

/**
 * A singleton used to handle destruction of the app. It is used to prevent the subscription leak in SSR mode.
 * Mainly used in Singletons created with `provideSingleton`.
 *
 * Use it for the `eternal subscriptions` which are supposed to work in the whole app lifetime.
 */
export class AppDestroy {
  private readonly _destroy$: Subject<void> = new Subject<void>();

  public get destroy$(): Observable<void> {
    return this._destroy$.asObservable();
  }

  public onAppDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}

export function provideAppDestroy(): AppDestroy {
  return provideSingleton(AppDestroy, () => new AppDestroy());
}
